// Portfolio Data Configuration
// This file contains all the data for the portfolio site, making it easy to edit and maintain

export const personalInfo = {
  name: "Michael R. Ellis",
  shortName: "Michael Ellis",
  title: "iOS Software Engineer",
  email: "Contact@MichaelRobertEllis.com",
  location: "NY USA",
  headline: "I've shipped iOS apps to millions.",
  support: "From the first build through the App Store.",
  heroCta: "Book a call"
};

export const experience = [
  { company: "Fetch", role: "iOS Software Engineer II", dates: "2026–Present" },
  { company: "Toyota", role: "Senior iOS Software Engineer", dates: "2025–2026" },
  { company: "Angi", role: "Senior iOS Software Engineer", dates: "2022–2025" },
  { company: "Duke Energy", role: "iOS Software Engineer", dates: "2018–2022" }
];

export const services = [
  {
    title: "iOS App Development",
    description: "Expert iOS development from concept to a shipped App Store release. I design, build, and launch production apps people actually use.",
    cta: "Start your iOS project"
  },
  {
    title: "Technical Consulting",
    description: "Architecture, planning, and code review from an engineer who has shipped production iOS apps.",
    cta: "Book a consultation"
  }
];

export const navigationItems = [
  { 
    name: 'GitHub', 
    link: "https://github.com/michael94ellis/",
    isExternal: true
  },
  { 
    name: 'LinkedIn', 
    link: "https://www.linkedin.com/in/michael94ellis/",
    isExternal: true
  },
  { 
    name: 'Medium', 
    link: "https://medium.com/@michaelrobertellis",
    isExternal: true
  },
  { 
    name: 'Contact', 
    link: "mailto:Contact@MichaelRobertEllis.com",
    isExternal: true
  }
];

export const projectCards = [
  {
    name: 'White Noise: Premium Serenity',
    link: '/white-noise',
    description: 'A white noise mixer for sleep and focus, with layered sounds, a sleep timer, and mixes that stay on your iPhone.',
    imgLink: '/hush/now-playing.gif',
    imageFit: 'contain',
    appstore: false,
    badges: false,
    cta: 'Learn more',
    category: 'iOS App'
  },
  { 
    name: 'Baby Soundboard & Toddler Games', 
    link: "/baby-soundboard", 
    description: "A free soundboard and toddler games app for babies and young children. No ads, no accounts, and no data collected.", 
    imgLink: "/baby-soundboard/tiles.jpg",
    imageFit: "contain",
    appstore: true,
    badges: false,
    cta: "Learn more",
    category: "iOS App"
  },
  { 
    name: 'Tuner Gauge: Chromatic Tuner', 
    link: "https://apps.apple.com/us/app/tuner-gauge-chromatic-tuner/id6751610479", 
    description: "A precision tuning utility with cent-level accuracy.", 
    imgLink: "tunergauge.png",
    appstore: true,
    badges: false,
    category: "iOS App"
  },
  {
    name: 'TimeDraw',
    link: "/TimeDraw",
    description: "Visualize your time. TimeDraw offers a circular calendar event representation around an analog clockface.",
    imgLink: "/timedraw/main-view.png",
    appstore: true,
    badges: false,
    cta: "Learn more",
    category: "iOS App"
  },
  { 
    name: 'iTello', 
    link: "https://apps.apple.com/us/app/itello/id1601051980", 
    description: "An iOS Drone Controller app for the DJI Tello drone.", 
    imgLink: "https://is5-ssl.mzstatic.com/image/thumb/Purple116/v4/25/01/0d/25010dee-9c93-b031-bf0f-d6ee0a2ce59b/AppIcon-1x_U007emarketing-0-7-0-85-220.png/230x0w.png", 
    appstore: true,
    badges: false,
    category: "iOS App"
  },
  { 
    name: 'File Crypt: Secure AES Browser',
    link: "https://apps.apple.com/us/app/file-crypt-secure-aes-browser/id6621263965", 
    description: "An AES-encryption based file storage utility for iOS for privacy and security.", 
    imgLink: "filesappicon.png", 
    appstore: true,
    badges: false,
    category: "iOS App"
  },
  { 
    name: 'Menu Calendar Quick View', 
    link: "/MenuCalendarQuickView", 
    description: "A colorful Mac menu bar calendar for the month, events, and reminders.", 
    imgLink: "/quick-menu-calendar/icon.png", 
    appstore: true,
    badges: false,
    cta: "Learn more",
    category: "macOS App"
  },
  { 
    name: 'SwiftUIJoystick', 
    link: "https://github.com/michael94ellis/SwiftUIJoystick", 
    description: "The leading SwiftUI Joystick package for iOS apps.", 
    imgLink: "https://github.com/michael94ellis/SwiftUIJoystick/raw/main/Readme_Assets/joystick-nice.gif", 
    appstore: false,
    badges: true,
    category: "Swift Package"
  },
  { 
    name: 'ToastWindow', 
    link: "https://github.com/michael94ellis/ToastWindow", 
    description: "A robust and flexible SwiftUI Popover package created using UIKit APIs for iOS apps.", 
    imgLink: "https://github.com/michael94ellis/ToastWindow/raw/main/screenshots/toptoast.gif", 
    appstore: false,
    badges: true,
    category: "Swift Package"
  }
];

export const combinedProjects = projectCards;

export const siteConfig = {
  title: "Michael Ellis | Experienced iOS Software Engineer",
  description: "iOS software engineer who ships production apps from the first build through the App Store. Previously at Toyota, Angi, Duke Energy, and Southwest Airlines.",
  theme: {
    primaryColor: "#4a5366",
    backgroundColor: "#f5f5f5",
    textColor: "#333333"
  },
  sections: {
    projects: {
      title: "iOS Apps"
    },
    services: {
      title: "What I Can Do For You"
    }
  },
  drawer: {
    width: 240,
    title: "Menu"
  }
};

export const footerInfo = {
  left: {
    name: personalInfo.name,
    email: personalInfo.email
  },
  right: {
    location: personalInfo.location
  }
};
